import { useCallback } from "react";

import { useActivationSetFavicons } from "../../hooks/useActivationSetFavicons";
import { AlertsFeed } from "../AlertsFeed";
import { Virtualized } from "../Virtualized";

import { useWebsiteContentAlertsQuery } from "./useWebsiteContentAlertsQuery";
import { WebsiteContentAlert } from "./WebsiteContentAlert";

export const WebsiteContentAlertsFeed = () => {
    const { data: contentItems = [], isLoading: isDataLoading } = useWebsiteContentAlertsQuery();
    const { favicons, isLoading: isFaviconsLoading } = useActivationSetFavicons();

    const getItemKey = useCallback((index: number) => `${contentItems[index].url}-${index}`, [contentItems]);

    return (
        <AlertsFeed
            isLoading={isDataLoading || isFaviconsLoading}
            isEmpty={!contentItems.length}
        >
            <Virtualized
                count={contentItems.length}
                getItemKey={getItemKey}
                renderItem={(index) => (
                    <WebsiteContentAlert
                        content={contentItems[index]}
                        favicon={favicons?.[contentItems[index].domain] ?? ""}
                    />
                )}
            />
        </AlertsFeed>
    );
};
